// Generated by scripts/sync-nav-icons.js from sgez_shared/icons/nav.
export const NAV_ICON_ASSETS = {
  'home': '/icons/nav/home.svg',
  'sales': '/icons/nav/sales-support.svg',
  'customer': '/icons/nav/customer-support.svg',
  'design': '/icons/nav/design-support.svg',
  'work': '/icons/nav/work-support.svg',
  'admin': '/icons/nav/admin.svg',
}

export function getNavSvgAsset(navItemId) {
  if (!navItemId) return null
  return NAV_ICON_ASSETS[navItemId] || null
}
